import React from 'react';
import '../../assets/css/test.css';

export default function Test() {

    return (
      <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap'}}>
        <h1 style={{fontSize: '30px', textAlign: 'center', margin: '30px 0', width: '100%'}}>TEST 페이지</h1>
        <a className='pcbtn' href="https://jijibaby.com/">
            PC 사용자 버튼
        </a>
        <a className='mobtn' href="https://studiob.kr/">
            모바일 사용자 버튼
        </a>
        <a className='gtmbtn' href="#">
            GTM 통합 버튼
        </a>
      </div>

    );
  };
  